import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";

@Component({ name: "DeviceRealTimeData" })
export default class DeviceRealTimeData extends Vue {
    public localizer: any = Localizer;
    public realTimeDataInterval: any = null;
    public deviceData: any = null;
    public realTimeData: any = null;
    public dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.userCulture };

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly deviceSerialNumber: string;

    public async created() {
        await this.getDeviceData();
        await this.getRealTimeData();

        this.setRealTimeDataInterval();
    }

    public setRealTimeDataInterval() {
        const interval = 5 * 1000; // 5 seconds
        let vm = this;
        this.realTimeDataInterval = setInterval(function () {
            vm.getRealTimeData();
        }, interval);
    }

    public async getDeviceData() {
        this.deviceData = (await Axios.post(this.routes.MyMectronicDevice_GetDeviceData, { serialNumber: this.deviceSerialNumber }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    }

    public async getRealTimeData() {
        this.realTimeData = (await Axios.post(this.routes.MyMectronicDevice_GetRealTimeData, { serialNumber: this.deviceSerialNumber }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    }

    public isDeviceParameter(parameter: string) {
        return this.deviceData.telemetryParameters.some(x => x === parameter);
    }

    public formatDateTimeOffset(dateItem: string): string {
        if (dateItem == null) {
            return "";
        }

        let date = new Date(dateItem);
        return date.toLocaleString((<any>window).App.culture, {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit"
        });
    }

    public formatSeconds(seconds: number): string {
        let hours: any = Math.floor(seconds / 3600);
        let minutes: any = Math.floor((seconds - (hours * 3600)) / 60);

        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        return hours + ':' + minutes;
    }
};